<div class="bookmarks-modal">
  <div class="modal-header">
    <h2>{{topTitle}}</h2>
  
    <button class="no-style close-btn" mat-dialog-close>
      <mat-icon [svgIcon]="'close'" class="square-icon close-icon" aria-label="close"></mat-icon>
    </button>
  </div>

  <div class="no-result" *ngIf="!isLoading && allBookmarks?.length === 0">
    <h2>{{popupData.popupNoResultsText}}</h2>
  </div>

  <mat-dialog-content *ngIf="allBookmarks.length > 0 || isLoading"  class="bookmarks-list">
    <ng-container *ngIf="allBookmarks.length">
      <div
        *ngFor="let bookmark of allBookmarks" 
        (click)="toggleBookmark(bookmark)" 
        [ngClass]="{'disabled': isSavingInProgress || (itemsToSelectLeft == 0 && !bookmark.selected)}" 
        class="bookmark-item-selector">
        <mat-checkbox
          class="radio-view"
          [checked]="bookmark.selected"
          [disabled]="isSavingInProgress || (itemsToSelectLeft == 0 && !bookmark.selected)"
        />
        <img class="bookmark-icon" [src]="bookmark.iconUrl">
        <div class="title-container">
          <span class="bookmark-text">{{bookmark.title}}</span>
        </div>
      </div>
    </ng-container>
    
    <ng-container *ngIf="isLoading">
      <div *ngFor="let _ of [].constructor(10)" class="bookmark-item-selector skeleton">
        <app-skeleton [height]="115"></app-skeleton>
      </div>
    </ng-container>
  </mat-dialog-content>

  <div class="modal-bottom-container">
    <button mat-stroked-button mat-dialog-close color="primary" [disabled]="isSavingInProgress || isLoading" class="mobile-btn cancel-button">
      {{popupData.cancelButtonText}}
    </button>

    <button mat-flat-button color="primary" [disabled]="isSavingInProgress || isLoading" (click)="saveChanges()" class="btn-md submit-filter save-button">
      {{popupData.saveButtonText}}
    </button>
  </div>
</div>